import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../_components/header/header.component';
import { BreadcrumbsComponent } from '../../_components/breadcrumbs/breadcrumbs.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, BreadcrumbsComponent],
})
export class LayoutComponent {

}
